import React, {Fragment, useState} from "react";
import LabelWithInfo from "../../../../components/LabelWithInfo/LabelWithInfo";
import MathUtils from "../../../../utils/MathUtils";

function RentalCalculationSummary({calculation, calculationParameters, offerElements}) {

    const [expanded, setExpanded] = useState(false);

    const elementsInPrice = offerElements.map(element => (
        <div key={element.code} className="calc__summary-row">
            <span className="calc__row-label"><LabelWithInfo infoCode={element.code}/></span>
            <span className="calc__row-value">w cenie</span>
        </div>
    ));

    return (
        <Fragment>
            <div className="calc__summary-header">
                <p className="calc__summary-title">Podsumowanie</p>
                <button type="button" className="calc__summary-toggle" onClick={() => setExpanded(e => !e)}>
                    {expanded ? "Zwiń składowe" : "Rozwiń składowe"}
                    <span className={"calc__summary-arrow" + (expanded ? " calc__summary-arrow--up" : "")}>›</span>
                </button>
            </div>

            {expanded && (
                <div className="calc__summary-rows">
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Okres wynajmu</span>
                        <span className="calc__row-value">{calculationParameters.contractLength} m-cy</span>
                    </div>
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Opłata wstępna</span>
                        <span className="calc__row-value">
                            {MathUtils.valueOfPercentage(calculation.vehiclePrice, calculationParameters.initialFeePercentage)} zł
                        </span>
                    </div>
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Rata wynajmu</span>
                        <span className="calc__row-value">{calculation.value} zł</span>
                    </div>
                    {elementsInPrice}
                </div>
            )}
        </Fragment>
    );
}

export default RentalCalculationSummary;
